import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from './useAuth';

/** Route guard: renders children only when signed in; else redirects to /login. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--muted)',
          fontSize: 13,
        }}
      >
        {t('auth.requireAuth.loading')}
      </div>
    );
  }

  if (status === 'signedOut') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
